module.exports = __webpack_public_path__ + "static/media/ic_sender.27b61750.svg";